import Validator from '@/shared/utils/validator'
import { createRouter, createWebHistory } from 'vue-router'

class RouterGenerator {
  constructor() {
    this.routes = []
    this.isAuthenticated = async () => true
  }

  setAuthChecker(checkingFunction) {
    if (typeof checkingFunction !== 'function') {
      console.log(
        '🚀 ~ RouterGenerator ~ setAuthChecker ~ checkingFunction:',
        checkingFunction,
      )
      throw new Error(
        `checkingFunction argument must be a function. received type ${typeof checkingFunction}`,
      )
    }

    this.isAuthenticated = checkingFunction
  }

  addRoutes(routes) {
    if (!Array.isArray(routes)) {
      console.log('🚀 ~ RouterGenerator ~ addRoutes ~ routes:', routes)
      throw new Error(`routes parametter must be an array`)
    }

    const routesToAdd = routes.map(route => {
      Validator.requireObject('route', route)
      Validator.requireObject('route.meta', route.meta)
      Validator.require('route.meta.title', route.meta.title, 'string')

      return {
        path: route.path,
        name: route.name,
        component: route.component,
        meta: { ...route.meta, needAuth: route.meta?.needAuth ?? true },
      }
    })
    this.routes.push(...routesToAdd)
  }

  generate() {
    const router = createRouter({
      history: createWebHistory(),
      routes: [
        ...this.routes,
        { path: '/_refresh', component: { template: '<div></div>' } },
      ],
    })

    router.reload = function () {
      const { fullPath, name, params, query } = router.currentRoute.value
      const refresh = Date.now()

      router.replace({ path: '/_refresh' }).then(() => {
        router.replace({
          name,
          params,
          query: { ...query, refresh },
        })
      })
    }

    router.beforeEach(async (to, from, next) => {
      const checkAuth = to.meta.checkAuth ?? true
      const needAuth = to.meta.needAuth ?? false

      if (checkAuth) {
        const userIsAuth = await this.isAuthenticated()
        if (to.meta?.title) document.title = to.meta.title
        if (needAuth && !userIsAuth) {
          const nonAuthRequiredRoute = this.routes.find(
            route => !route.meta?.needAuth,
          )
          if (!nonAuthRequiredRoute?.name) return next()
          return next({ name: nonAuthRequiredRoute.name })
        }
        if (!needAuth && userIsAuth) {
          const authRequiredRoute = this.routes.find(
            route => route.meta?.needAuth,
          )
          if (!authRequiredRoute?.name) return next()
          return next({ name: authRequiredRoute.name })
        }
      }
      next()
    })

    return router
  }
}

export default RouterGenerator
